import { render, staticRenderFns } from "./NewSheet.vue?vue&type=template&id=ba12b1c0"
import script from "./NewSheet.vue?vue&type=script&lang=js"
export * from "./NewSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports